import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder

const BASE = serviceName + '/learning/chapter'

export function getChapterPage(data) {
  return request({
    url: BASE + '/page',
    method: 'post',
    data,
  })
}

export function getChapterList(courseId) {
  return request({
    url: serviceName + '/learning/course/detail/' + courseId,
    method: 'get',
  })
}

export function addChapter(data) {
  return request({
    url: BASE + '/add',
    method: 'post',
    data,
  })
}

export function updateChapter(data) {
  return request({
    url: BASE + '/update',
    method: 'post',
    data,
  })
}

export function deleteChapter(id) {
  return request({
    url: BASE + '/delete/' + id,
    method: 'post',
  })
}

export function setChapterStatus(id, status) {
  return request({
    url: BASE + '/status/' + id,
    method: 'post',
    params: { status },
  })
}